var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChipRight1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 136,
    viewBox: "0 0 266 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -8,
    width: 284,
    height: 152
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_2052_8412_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4069 115.322C4.63693 113.293 0 107.063 0 99.9956L0 18C0 9.16344 7.16344 2 16 2L248 2C256.837 2 264 9.16344 264 18L264 118C264 126.837 256.837 134 248 134L76.079 134C74.5234 134 72.9761 133.773 71.486 133.327L11.4069 115.322Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0791 133.5L248 133.5C256.56 133.5 263.5 126.56 263.5 118L263.5 18C263.5 9.43958 256.56 2.5 248 2.5L16 2.5C7.43959 2.5 0.5 9.43959 0.5 18L0.5 99.9961C0.500204 106.628 4.71558 112.5 10.9414 114.647L11.5508 114.843L71.6299 132.848C73.0733 133.28 74.5722 133.5 76.0791 133.5Z",
    stroke: "url(#paint0_linear_2052_8412)",
    strokeOpacity: 0.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169 2H248C256.837 2 264 9.16344 264 18V118C264 126.837 256.837 134 248 134H169",
    stroke: "url(#paint1_linear_2052_8412)",
    strokeOpacity: 0.7,
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2052_8412_clip_path",
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4069 115.322C4.63693 113.293 0 107.063 0 99.9956L0 18C0 9.16344 7.16344 2 16 2L248 2C256.837 2 264 9.16344 264 18L264 118C264 126.837 256.837 134 248 134L76.079 134C74.5234 134 72.9761 133.773 71.486 133.327L11.4069 115.322Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2052_8412",
    x1: 29.04,
    y1: 121.575,
    x2: 73.9206,
    y2: -48.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2052_8412",
    x1: 169,
    y1: 68,
    x2: 264,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.081934,
    stopColor: "#15BFFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706057,
    stopColor: "#15BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipRight1);
export default __webpack_public_path__ + "static/media/chipRight1.cc66c3184f32e47767b89aa034f5a9f3.svg";
export { ForwardRef as ReactComponent };